<template>
  <div>
    <div class="router-header flex flex-wrap items-center mb-3 justify-content-center">
      <div
        class="content-area__heading pr-4"
      >
        <h4 class="mb-2">{{ $t("endorsementInvite.invitePeople.ip1") }}</h4>

      </div>
    </div>

    <div class="vx-col w-full mb-2">
      <div class="mt-4 mb-1">
<!--        {{ $t("endorsementInvite.invitePeople.ip2") }}-->
      </div>
      <vs-input
        v-validate="'required|email'"
        data-vv-validate-on="blur"
        :label-placeholder="$t('endorsementInvite.lbl1')"
        name="email"
        v-model="email"
        class="w-full "
        style="text-align: left;"
        icon-pack="feather"
        icon="icon-mail"
        icon-no-border
      />
      <span class="text-danger text-sm" v-show="errors.has('email')">{{
        errors.first("email")
      }}</span>
      <vs-input
        v-validate="'required|min:3'"
        data-vv-validate-on="blur"
        name="inviteUserName"
         :label-placeholder="$t('endorsementInvite.lbl2')"
        style="text-align: left;margin-top:25px;"
        icon-pack="feather"
        icon="icon-user"
        icon-no-border
        v-model="inviteUserName"
        class="w-full" />
      <span class="text-danger text-sm">{{ errors.first('inviteUserName') }}</span>

    </div>

    <div class="text-center mb-base">
      <vs-button @click="addToEmailList" :disabled="!validateForm" style="margin-top:25px;">{{ $t("endorsementInvite.invitePeople.ip3") }}</vs-button>
    </div>

    <vx-card v-for="i in emailList.length" :key="i" class="mb-2">
      <div class="float-left" v-show=" emailList[i - 1].count===1">New Rater being added to your advisor circle,<a class="ml-2" title="System follow-up is sent once, follow-up again with your personal email" :href="'mailto:'+ emailList[i - 1].email+'?subject='+coachType+' Feedback request from '+userName+' &body=Hi '+emailList[i - 1].inviteUserName+'  %0d%0a'+
' %0d%0a'+
' %0d%0a'+
'During the next few months I will be working on improving my skills using the tool ' +
 coachType+', I require your help to measure my progress over time.\n'+
' %0d%0a %0d%0a'+
'The Coach system will send you emails periodically, you just have to use the ‘toggle’ in the email, to indicate if the gap to reach my development goal is: “closing”, “getting bigger” or if you think the “gap remains the same”.\n'+
' %0d%0a %0d%0a'+
'Completing these assessments will help me a lot to understand if I am making progress in my development and will only take a minute.\n %0d%0a %0d%0a'+
'I appreciate your help in this process, if you have any questions you can contact me directly and if you need technical help you can contact the ' +
 coachType+ 'team at support@getboarded.com\n %0d%0a %0d%0a'+
 '\n %0d%0a'+
 'Thank You\n %0d%0a'+
  userName
">invite {{ emailList[i - 1].inviteUserName }} as your rater on Coach.</a></div><br>
      <div class="float-left">{{$t('endorsementInvite.lbl1')}} : {{ emailList[i - 1].email }}</div><br>
      <div class="float-left">{{$t('endorsementInvite.lbl2')}}  : {{ emailList[i - 1].inviteUserName }} </div><br>
    </vx-card>
  </div>
</template>

<script>
import i18n from "@/i18n/i18n";
export default {
  name: "InvitePeople",
  data() {
    return {
      email: "",
      inviteUserName:"",
      emailList: [],
     };
  },
  computed: {
    userName(){
      return  this.traineeName=this.$store.state.AppActiveUser.firstName+' '+this.$store.state.AppActiveUser.lastName;
    },
    validateForm () {
      return !this.errors.any()  && this.email !== '' && this.inviteUserName !== ''
    },
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    coachType(){
      if(window.$cookies.get('companyName')==='GALA.GAMES'){
        return "Mentor";

      }else{
        return "Coach";
      }
    }
  },
  methods: {
    emailAlreadyPresent(email){
      this.$store.dispatch("endorsement-invite/find", {query: {inviteeEmail: email}}).then(res => {
        if(res.total > 0){
          this.$vs.notify({
            color: "primary",
            title: i18n.t('notification.user.skillDetails.invite.emailFind.e1'),
            text:  i18n.t('notification.user.skillDetails.invite.emailFind.e2')
          });
        }
      }).catch(err => {
        console.log("this is a new invitee email-id", err);
      })

    },
    addToEmailList() {
      if (!this.emailList.includes(this.email)) {

        this.$store.dispatch("endorsement-invite/find", {query: {inviteeEmail: this.email, traineeCompetenciesId: this.$route.params.traineeCompetenciesId }}).then(res1 => {

          if(res1.total > 0){
            this.$vs.notify({
              color: "primary",
              title: i18n.t('notification.user.skillDetails.invite.emailFind.e1'),
              text:  i18n.t('notification.user.skillDetails.invite.emailFind.e2')
            });
          }
          else{
            let data= JSON.parse(localStorage.getItem('userInfo'));

            this.$store.dispatch("users/find", {query: {email: this.email,id:data.usersId}}).then(res => {
              console.log(res.data);
              if(res.total > 0){
                this.$vs.notify({
                  color: "primary",
                  title: i18n.t('notification.user.skillDetails.invite.userFind.u1'),
                  text:  i18n.t('notification.user.skillDetails.invite.userFind.u2')
                });
              }else{
                let count=0;
                this.$store.dispatch("endorsement-invite/find", {query: {inviteeEmail: this.email,userId:data.usersId}}).then(res => {
                  console.log(res);
                  if(res.total > 0){
                    count =0;
                  }else{
                    count =1;
                  }
                  const inviteUser={
                    email:this.email,
                    inviteUserName:this.inviteUserName,
                    count:count
                  }
                  this.$store
                    .dispatch("endorsementInvite/setEmailList", inviteUser)
                    .then(res => {
                      this.email='';
                      this.inviteUserName='';
                      console.log("email pushed to store", res);
                      this.emailList.push(inviteUser);
                      console.log(this.emailList);
                    })
                    .catch(err => {
                      console.log("email could not be pushed to store", err);
                    });
                }).catch(err => {
                  console.log("error finding email", err);
                })
              }
            }).catch(err => {
              console.log("this is a new invitee email-id", err);
            })

          }
        }).catch(err => {
          console.log("error finding email", err);
        })
      }
    }
  }
};
</script>

<style scoped>
.borderBottom {
  border-bottom: 1px solid black;
}

.note-to-coach {
  margin-top: 5rem !important;
  padding: 2rem !important;
  text-align: center;
}

.justify-content-center {
  justify-content: center;
}
</style>
